import { render, staticRenderFns } from "./lottery-PCDD.vue?vue&type=template&id=18d26873&scoped=true"
import script from "./lottery-PCDD.vue?vue&type=script&lang=js"
export * from "./lottery-PCDD.vue?vue&type=script&lang=js"
import style0 from "./lottery-PCDD.vue?vue&type=style&index=0&id=18d26873&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d26873",
  null
  
)

export default component.exports